export default __webpack_public_path__ + "static/media/maes_profile.507982f0.jpg";